// Normalize codes without converting to numbers: '01' and '1' remain distinct.
const code = (value) =>
  String(value ?? '')
    .trim()
    .toUpperCase();
const text = (value) => String(value ?? '').trim();

export function getEffectiveFreightAccount(rows, shipToCode) {
  const exact = rows.find((row) => code(row.shipToCode) === code(shipToCode));
  const fallback = rows.find((row) => code(row.shipToCode) === '');
  return text((exact || fallback)?.accountNo);
}

export function buildFreightAccountPreview({
  customerNo,
  carrier,
  shipToCode,
  scope,
  savedRows,
  shipTos,
}) {
  const saved = new Map(savedRows.map((row) => [code(row.shipToCode), row]));
  const current = code(shipToCode);
  const targets =
    scope === 'shipto'
      ? new Set(current ? [current] : [])
      : new Set([
          ...shipTos.map(code).filter(Boolean),
          ...saved.keys(),
          ...(current ? [current] : []),
        ]);
  return [...targets]
    .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }) || a.localeCompare(b))
    .map((ship) => ({
      customerNo: code(customerNo),
      shipToCode: ship,
      carrier: code(carrier),
      accountNo: text(saved.get(ship)?.accountNo),
      saved: saved.has(ship),
    }));
}
